<div class="mt-3 mb-2 mb-3 form-inline">
  <h5 class="col" i18n>Acknowledgements</h5>
</div>

<div *ngFor="let acknowledgement of quoteAcknowledgements">
  <div class="card border-bidit-dark bg-light mb-3 shadow">
    <div class="card-body">
      <div class="row mb-2">
        <span class="col-7 text-bidit-primary-header">{{quote.quote_Name}}</span>       
      </div>
      <p>
        <span><span>Acknowledgement ID:</span>{{acknowledgement.quoteAcknowledgement_ID}} </span>
        <span *ngIf="quote.quote_Converted != undefined">{{changeOrderLabel(acknowledgement.changeOrder_ID)}}</span>
      </p>
      <div>
        <span><span i18n>Status:</span> {{acknowledgement.acknowledgementStatusDesc}}</span>
      </div>
      <div>
        <span class="text-bidit-primary"><span i18n>Acknowledgment Sent:</span> {{acknowledgement.dateSent | date:'MM/dd/yyyy  HH:mm:ss'}} </span>
      </div>
      <div>
        <span class="text-bidit-primary"><span i18n>Acknowledged Date:</span> {{acknowledgement.acknowledgedDate | date:'MM/dd/yyyy  HH:mm:ss'}} </span>
      </div>
      <div *ngIf="acknowledgement.acceptedQuoteRejectedDate != null">
        <span class="text-bidit-primary"><span i18n>Accepted Quote Rejected:</span> {{acknowledgement.acceptedQuoteRejectedDate | date:'MM/dd/yyyy  HH:mm:ss'}} </span>
      </div>
      <div>
        <span class="text-bidit-primary"><span i18n>Expiry Date:</span> {{acknowledgement.acknowledgedDate != null ? '' : acknowledgement.expiryDate | date:'MM/dd/yyyy HH:mm:ss'}} </span>
      </div>
      <div>
        <button *ngIf="acknowledgement.acknowledgedDate != null" (click)="downloadAttachment(acknowledgement)" class="btn btn-bidit-navigate mr-1" i18n>Download</button>
      </div>
    </div>
  </div>
</div>
